import { render, staticRenderFns } from "./RichHorizontalIndicator.vue?vue&type=template&id=0a6effdc&scoped=true"
import script from "./RichHorizontalIndicator.vue?vue&type=script&lang=js"
export * from "./RichHorizontalIndicator.vue?vue&type=script&lang=js"
import style0 from "./RichHorizontalIndicator.vue?vue&type=style&index=0&id=0a6effdc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6effdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a6effdc')) {
      api.createRecord('0a6effdc', component.options)
    } else {
      api.reload('0a6effdc', component.options)
    }
    module.hot.accept("./RichHorizontalIndicator.vue?vue&type=template&id=0a6effdc&scoped=true", function () {
      api.rerender('0a6effdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-wizard-kyc/indicators/RichHorizontalIndicator.vue"
export default component.exports